<template>
  <div>
    <Form class="i-form" @submit.native.prevent="preventSubmit" :label-width="30">
      <FormItem>
        <Button type="primary" @click="editBtn" v-if="!editing">更改设置</Button>
        <Button type="primary" @click="saveBtn" v-if="editing">保存</Button>
        <Button @click="addBedType" v-if="editing">添加床数</Button>
      </FormItem>
      <FormItem v-if="errMsg">
        <p class="err-msg">* {{ errMsg }}</p>
      </FormItem>
      <FormItem v-if="!consumableFeeList.length">
        <p style="font-size: 14px; color: #495060;">暂无易耗品费设置项</p>
      </FormItem>
      <FormItem v-for="(item, index) in consumableFeeList" :key="index">
        <p v-if="!editing" style="font-size: 14px;">
          床数：<span style="margin: 0 50px 0 25px;">{{ item.bedNum }}</span>
          易耗品：<span style="margin: 0 50px 0 25px;">{{ item.consumableCharging }}</span>
        </p>
        <div v-else>
          <label class="ivu-form-item-label" style="width: 150px; display: inline-block;">床数：
            <Input type="text" v-model="item.bedNum" style="width:80px"></Input>
          </label>
          <label class="ivu-form-item-label" style="width: 180px; display: inline-block;">易耗品：
            <Input type="text" v-model="item.consumableCharging" style="width:80px"></Input>
          </label>
          <Button type="error" style="margin: 10px 12px 10px 25px;" @click="deleteBedType(index)">删除</Button>
        </div>
      </FormItem>
    </Form>
    <!-- 确认弹窗 -->
    <Modal ref="confirmModal" :loading="true" v-model="confirmModal" width="400"
      :closable="false" ok-text="确认保存"
      @on-ok="consumableChargingEdit">
      <p class="close-tips">保存后立即生效！</p>
      <p class="close-tips">新结束的清洁单将按新标准计算费用！</p>
      <p class="close-tips">确认保存？</p>
    </Modal>
  </div>
</template>

<script>
/* eslint-disable */
import Utils from '@/utils'
import API from '@/api'

export default {
  data () {
    return {
      consumableFeeList: [], // 表格列表数据
      editing: false, // 是否编辑状态
      errMsg: '', // 错误信息
      confirmModal: false // 是否显示确认弹窗
    }
  },

  created () {
		this.token = Utils.findFromLocalStorage('vue-token');
		this.username = Utils.findFromLocalStorage('vue-username');
		this.env = Utils.findFromLocalStorage('env', 'dev');
    this.AuthorToken = Utils.findFromLocalStorage('Author-token');
    this.headerENV = Utils.aliHeaderEnv(this.env)
    this.aliyunTestENV = process.env.NODE_ENV === 'development' ? 'dev' : 'qa'
	},

  mounted () {
    this.$Notice.config({
			top: 150
    })
    if (!Utils.hasPermission('xbCleanAttachedCharging_list')) {
      this.$Notice.error( {
        title: '无权限操作'
      })
      return
    }
    this.consumableChargingList()
  },

  methods: {
    // 易耗品费列表
    async consumableChargingList () {
      if (!Utils.hasPermission('xbCleanAttachedCharging_list')) {
        this.$Notice.error( {
          title: '无权限操作'
        })
        return
      }
      let params = {
        page: 1,
        size: 99
      }
      let res = (await API.omsAPI[this.env].clientServer.consumableChargingList(params, {
        'x-ca-stage': this.headerENV,
        'Authorization': this.AuthorToken,
        // 'Right': this.token,
        // 'group': this.aliyunTestENV
      })).data
      if (res.retCode || res.code !== '0000') {
        this.$Notice.error( {
          title: '错误',
          desc: `获取易耗品费列表失败：${res.msg}`
        })
        return
      }
      this.consumableFeeList = res.data
    },

    // 更改设置按钮
    editBtn () {
      if (!Utils.hasPermission('xbCleanConsumableCharging_edit')) {
        this.$Notice.error( {
          title: '无权限操作'
        })
        return
      }
      this.editing = true
    },

    // 保存按钮
    saveBtn () {
      let allParamsValidated = true
      let count = 0
      this.consumableFeeList.map(item => {
        this.consumableFeeList.map(innerItem => {
          if (item.bedNum * 1 === innerItem.bedNum * 1) {
            count = count + 1
          }
        })
        if (!item.bedNum || !(/^\+?[1-9][0-9]?$/.test(item.bedNum))) {
          this.errMsg = '请正确输入床数！'
          allParamsValidated = false
        } else if (!item.consumableCharging || !(/^(([1-9][0-9]{0,2})|(([0]\.\d{1,2}|[1-9][0-9]{0,2}\.\d{1,2})))$/.test(item.consumableCharging))) {
          this.errMsg = '请正确输入易耗品费用！（价格最多保留两位小数）'
          allParamsValidated = false
        }
      })
      if (count > this.consumableFeeList.length) {
        this.errMsg = '床数不可重复设置，请检查！'
        return
      }
      if (!allParamsValidated) {
        return
      }
      this.confirmModal = true
    },

    // 添加床数
    addBedType () {
      this.consumableFeeList.push({
        bedNum: null,
        consumableCharging: null
      })
    },

    // 删除床数
    deleteBedType (index) {
      this.consumableFeeList.splice(index, 1)
    },

    // 编辑易耗品费
    async consumableChargingEdit () {
      let params = {
        chargingList: JSON.stringify(this.consumableFeeList),
        createName: this.username
      }
      console.info(params)
      let res = (await API.omsAPI[this.env].clientServer.consumableChargingEdit(params, {
        'x-ca-stage': this.headerENV,
        'Authorization': this.AuthorToken,
        // 'Right': this.token,
        // 'group': this.aliyunTestENV
      })).data
      if (res.retCode || res.code !== '0000') {
        this.errMsg = ''
        this.confirmModal = false
        this.$Notice.error( {
          title: '错误',
          desc: `编辑易耗品费失败：${res.msg}`
        })
        return
      }
      this.errMsg = ''
      this.confirmModal = false
      this.editing = false
      this.consumableChargingList()
    },

    // 防止表单自动提交
    preventSubmit () {
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.ivu-form-item-label {
  &::before {
    content: '*';
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 12px;
    color: #ed3f14;
  }
}
.err-msg {
  color: #ed3f14;
  font-size: 12px;
  font-family: SimSun;
}
.close-tips {
  color: #495060;
  font-size: 14px;
  text-align: center;
  margin: 5px 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/cleaner/additional-fee/consumables-fee.vue